import styled from '@emotion/styled';

export const FilterWrapper = styled('div', { label: 'FilterWrapper' })`
    display: flex;
    justify-content: flex-end;
`;

export const Header = styled('header', { label: 'Header' })`
    margin-bottom: 5px;
`;
